module.exports = __webpack_public_path__ + "img/SE powered by FVC narrow.31bf6290.png";